// extracted by mini-css-extract-plugin
export default {"selectDayButtons":"daySelectionWeekDays_selectDayButtons__6N7Uz","selected":"daySelectionWeekDays_selected__qa5xW","dayName":"daySelectionWeekDays_dayName__1htIp"};